type TrackingPayload = Record<string, string | number | boolean | null | undefined>;

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
    gtag?: (...args: unknown[]) => void;
  }
}

export function pushDataLayerEvent(eventName: string, payload: TrackingPayload = {}) {
  if (typeof window === "undefined") return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...payload,
  });
}

export function sendGtagEvent(eventName: string, payload: Record<string, unknown> = {}) {
  if (typeof window === "undefined") return;

  const dispatch = () => {
    if (typeof window.gtag !== "function") return false;
    window.gtag("event", eventName, payload);
    return true;
  };

  if (dispatch()) return;

  let attempts = 0;
  const maxAttempts = 8;
  const retryDelayMs = 250;

  const retryDispatch = () => {
    attempts += 1;
    if (dispatch()) return;
    if (attempts < maxAttempts) {
      window.setTimeout(retryDispatch, retryDelayMs);
    }
  };

  window.setTimeout(retryDispatch, retryDelayMs);
}
